import styled from 'styled-components';

const RecentContainer = styled.section`
  width: 100%;
  height: 300px;
  margin-left: 8px;
  height: 100%;
  margin-top: 5px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const RecentText = styled.p`
  color: white;
  font-size: 0.7rem;
  padding: 10px;
  padding-left: 15px;
  margin-top: -8px;
  width: 80%;
`;

export { RecentContainer, RecentText };
